<template xmlns="http://www.w3.org/1999/html">
  <div v-if="authenticatedUser">
    <!-- page main-->
    <main class="creation" role="main">
      <!-- sub header-->
      <section class="subheader">
        <div class="container">
          <!-- left-->
          <div class="title">
            <div class="centered d-flex align-items-center">
              <div class="wraps">
                <h2>Create New Recipe</h2>
              </div>
            </div>
          </div>
          <!-- action-->
          <ul class="action">
            <router-link :to="{ name: 'recipes' }">
              <li class="cancel"><a href="#">Cancel</a></li>
            </router-link>
            <li><a class="orange" @click="checkForm" href="#">Save</a></li>
          </ul>
        </div>
      </section>
      <!-- wrap-->
      <div class="container-fluid px-6">
        <div class="row form">
          <!-- left-->
          <div class="col-lg-4 left">
            <!-- scrollspy-->
            <b-navbar class="navbar" sticky>
              <b-nav class="navbar nav">
                <b-nav-item
                  class="nav-link"
                  href="#basic-form"
                  @click.prevent="scrollTo('basicform', $event)"
                >
                  <div class="counter">
                    <div class="wrap">1</div>
                  </div>
                  <div class="text">
                    <h2>Basic Information</h2>
                    <p>
                      Some important recipe of the ingredient to get you started
                      quickly
                    </p>
                  </div>
                </b-nav-item>

                <b-nav-item
                  class="nav-link"
                  href="#advanced-form"
                  @click.prevent="scrollTo('advancedform', $event)"
                >
                  <div class="counter">
                    <div class="wrap">2</div>
                  </div>
                  <div class="text">
                    <h2>Advanced Information</h2>
                    <p>
                      Describing the steps, challenges, and ingredients of your
                      recipe can be very helpful for others who wish to
                      implement a similar project.
                    </p>
                  </div>
                </b-nav-item>
              </b-nav>
            </b-navbar>
          </div>

          <!-- left-->
          <div class="col-lg-8 right">
            <div class="wraps">
              <div class="basic-form" id="basic-form" ref="basicform">
                <!-- heading-->
                <div class="heading main top">
                  <h1>Basic Information</h1>
                  <p>
                    Document your experience from past projects or your ideas
                    for new projects as recipes. The recipe structure has been
                    designed to capture the much needed “inside” knowledge of
                    participatory projects, so that others can learn from it and
                    reuse its elements, depending on their needs.
                  </p>
                </div>
                <div class="row">
                  <div class="col">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Recipe Title<span class="mandatory"
                          >Mandatory</span
                        ></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Enter recipe title"
                        v-model="title"
                      />
                      <b-alert
                        dismissible
                        v-model="emptyTitleAlert"
                        variant="danger"
                      >
                        You have to provide a title!
                      </b-alert>
                    </div>
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Recipe Description<span class="mandatory"
                          >Mandatory</span
                        ></label
                      >
                      <textarea
                        class="form-control"
                        rows="5"
                        placeholder="Enter recipe description"
                        v-model="description"
                      ></textarea>
                      <b-alert
                        dismissible
                        v-model="emptyDescriptionAlert"
                        variant="danger"
                      >
                        You have to provide a description!
                      </b-alert>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Recipe Banner<span class="mandatory"
                          >Mandatory</span
                        ></label
                      >
                      <div
                          class="
                            font-italic font-weight-light
                            text-secondary
                            mt-n2
                          "
                          v-if="!this.file && this.bannerUrl"
                          >View your current banner
                          <a
                            :href="this.bannerUrl"
                            rel="noopener noreferrer"
                            target="_blank"
                            >here</a>
                        </div>
                      <input
                        class="form-control h-100"
                        type="file"
                        :state="Boolean(file)"
                        placeholder="Browse your banner"
                        @change="bannerChanged($event)"
                      />
                      <b-alert
                        dismissible
                        v-model="emptyBannerAlert"
                        variant="danger"
                      >
                        You have to provide a banner!
                      </b-alert>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Areas of Focus<span class="mandatory"
                          >Mandatory</span
                        ></label
                      >
                      <select
                        class="multi-select form-select"
                        aria-label="Default select example"
                        multiple="multiple"
                        data-max-shown="3"
                        id="focusmulti"
                      >
                        <option value="Arts and heritage">
                          Arts and heritage
                        </option>
                        <option value="Community development">
                          Community development
                        </option>
                        <option value="Education">Education</option>
                        <option value="Human rights">Human rights</option>
                        <option value="Intercultural understanding">
                          Intercultural understanding
                        </option>
                        <option value="Interreligious understanding">
                          Interreligious understanding
                        </option>
                        <option value="Job placement/employment">
                          Job placement/employment
                        </option>
                        <option value="Leisure and entertainment">
                          Leisure and entertainment
                        </option>
                        <option value="Skills development">
                          Skills development
                        </option>
                        <option value="Social inclusion">
                          Social inclusion
                        </option>
                        <option value="Other">Other</option>
                      </select>
                      <div
                        class="specify"
                        v-if="selectedFocusAreas.includes('Other')"
                      >
                        <label
                          class="form-label"
                          for="exampleFormControlInput1"
                        >
                          Please Specify</label
                        >
                        <b-form-input
                          class="form-control"
                          type="text"
                          placeholder="Enter the focus area of the recipe"
                          v-model="additionalFocusArea"
                        />
                      </div>
                      <b-alert
                        dismissible
                        v-model="emptySelectedFocusAreasAlert"
                        variant="danger"
                      >
                        You have to specify at least one area of focus!
                      </b-alert>
                    </div>
                  </div>
                </div>
                <!-- horizontal line-->
                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Duration</label
                      >
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="duration"
                      >
                        <option value="" selected>
                          Select duration of the recipe
                        </option>
                        <option
                          v-for="d in Duration"
                          :value="d.value"
                          :title="d.text"
                          :key="d.text"
                        >
                          {{ d.value }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Cost</label
                      >
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="cost"
                      >
                        <option value="" selected>
                          Select cost of the recipe
                        </option>
                        <option
                          v-for="c in Cost"
                          :value="c.value"
                          :title="c.text"
                          :key="c.text"
                        >
                          {{ c.value }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        URL</label
                      >
                      <input
                        class="form-control"
                        type="text"
                        v-model="url"
                        placeholder="Link to website about the project, if available"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Number of Participants</label
                      >
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="numberOfParticipants"
                      >
                        <option value="" selected>
                          Select number of participants
                        </option>
                        <option
                          v-for="part in NumberOfParticipants"
                          :value="part.value"
                          :title="part.text"
                          :key="part.text"
                        >
                          {{ part.value }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Recipe Visibility</label
                      >
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="visibility"
                        @change="visibilityChanged"
                      >
                        <option value="" selected>
                          Select visibility of recipe
                        </option>
                        <option value="Private">Private</option>
                        <option value="Public">Public</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Recipe Status</label
                      >
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="status"
                        @change="statusChanged"
                      >
                        <option value="" selected>Select recipe status</option>
                        <option value="Completed">Completed</option>
                        <option value="New or ongoing project idea">
                          New or ongoing project idea
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Languages</label
                      >
                      <select
                        class="multi-select form-select"
                        aria-label="Default select example"
                        multiple="multiple"
                        data-max-shown="3"
                        id="languagemulti"
                      >
                        <option value="Arabic">Arabic</option>
                        <option value="Chinese">Chinese</option>
                        <option value="English">English</option>
                        <option value="Finnish">Finnish</option>
                        <option value="French">French</option>
                        <option value="German">German</option>
                        <option value="Greek">Greek</option>
                        <option value="Italian">Italian</option>
                        <option value="Spanish">Spanish</option>
                        <option value="Other">Other (specify)</option>
                      </select>
                      <div class="specify" v-if="languages.includes('Other')">
                        <label
                          class="form-label"
                          for="exampleFormControlInput1"
                        >
                          Please Specify</label
                        >
                        <b-form-input
                          class="form-control"
                          type="text"
                          placeholder="Enter the language of the ingredient"
                          v-model="additionalLanguage"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Countries</label
                      >
                      <select
                        class="multi-select form-select"
                        aria-label="Default select example"
                        multiple="multiple"
                        data-max-shown="3"
                        id="countrymulti"
                      >
                        <option value="Germany">Germany</option>
                        <option value="Greece">Greece</option>
                        <option value="Finland">Finland</option>
                        <option value="Italy">Italy</option>
                        <option value="Netherlands">Netherlands</option>
                        <option value="Spain">Spain</option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="Other">Other (specify)</option>
                      </select>
                      <div class="specify" v-if="countries.includes('Other')">
                        <label
                          class="form-label"
                          for="exampleFormControlInput1"
                        >
                          Please Specify</label
                        >
                        <b-form-input
                          class="form-control"
                          type="text"
                          placeholder="Enter the language of the ingredient"
                          v-model="additionalCountry"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Tags (Press Enter after each keyword)</label
                      >
                      <tags-input
                        :typeahead="true"
                        element-id="keywords"
                        v-model="keywords"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="heading">
                  <h2>Target Groups</h2>
                  <span class="mandatory">Mandatory</span>
                </div>
                <div class="row">
                  <div class="col-lg-1 col-sm-1 ic">
                    <img src="../assets/ic-target.png" />
                  </div>
                  <div class="col-lg-11 col-sm-11">
                    <div class="mb-3">
                      <select
                        class="multi-select form-select"
                        aria-label="Select target groups"
                        multiple="multiple"
                        data-max-shown="6"
                        id="groupmulti"
                      >
                        <option value="Disadvantaged or vulnerable groups">
                          Disadvantaged or vulnerable groups
                        </option>
                        <option value="Elderly people">Elderly people</option>
                        <option value="LGBTQI+">LGBTQI+</option>
                        <option value="Migrants">Migrants</option>
                        <option value="Minorities">Minorities</option>
                        <option value="Refugees and asylum seekers">
                          Refugees and asylum seekers
                        </option>
                        <option value="Unemployed">Unemployed</option>
                        <option value="Women">Women</option>
                        <option value="Youth">Youth</option>
                        <option value="Other">Other</option>
                      </select>
                      <div
                        class="specify half"
                        v-if="targetGroup[0].type.includes('Other')"
                      >
                        <label
                          class="form-label"
                          for="exampleFormControlInput1"
                        >
                          Please Specify</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          placeholder=""
                          v-model="additionalTargetGroupType"
                        />
                      </div>
                      <b-alert
                        dismissible
                        v-model="emptyTargetTypeAlert"
                        variant="danger"
                      >
                      </b-alert>
                    </div>
                  </div>
                </div>
                <div class="heading">
                  <h2>Collaborators</h2>
                  <ul class="actionmenu">
                    <li class="prime">
                      <a
                        title="Describe the collaborator as part of the recipe description"
                        v-b-tooltip.hover.top
                        href="javascript:void(0)"
                        @click.prevent="addNewNonExistingCreator"
                        ><i class="fas fa-plus"></i> Add New Collaborator</a
                      >
                    </li>
                    <li class="prime">
                      <a
                        href="javascript:void(0)"
                        @click="searchForCollaborator()"
                        title="Search for an existing organisation registered in the platform and add it as a collaborator."
                        v-b-tooltip.hover.bottom
                        ><i class="fas fa-plus"></i> Add Existing
                        Collaborator</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="empty">
                      <p
                        v-if="
                          creators.length === 0 &&
                          chosenCollaborators.length === 0
                        "
                      >
                        No Collaborators added yet. Please mention the
                        organisations who collaborated (or are expected to
                        collaborate) in this recipe”.
                      </p>
                    </div>
                    <div>
                      <div
                        class="element-item"
                        v-for="(col, index) in chosenCollaborators"
                        :key="col.id"
                      >
                        <div class="row">
                          <div class="col-lg-1 col-sm-1 ic">
                            <img src="../assets/ic-collaborator.png" />
                          </div>
                          <div class="col-lg-10 col-sm-10">
                            <a title="">
                              <h2>{{ col.name }}</h2></a
                            >
                            <p>
                              {{ col.description }}
                            </p>
                            <span class="typelocation">{{
                              col.type.toString()
                            }}</span>
                          </div>
                          <div class="col-lg-1 col-sm-1 action">
                            <ul>
                              <li>
                                <a
                                  class="delete"
                                  href="javascript:void(0)"
                                  @click="deleteCollaborator(index)"
                                  title="Delete this creator"
                                  ><i class="far fa-trash-alt"></i
                                ></a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <hr
                        v-if="
                          (creators.length === 0 &&
                            chosenCollaborators.length === 0) ||
                          chosenCollaborators.length !== 0
                        "
                      />
                      <b-row
                        :key="index"
                        class="mt-3 col-12"
                        v-for="(creator, index) in creators"
                      >
                        <div class="element-item manual" id="add-creator-form">
                          <div class="row">
                            <div class="col-lg-1 col-sm-1 ic">
                              <img src="../assets/ic-collaborator.png" />
                            </div>
                            <div class="col-lg-10 col-sm-10">
                              <div class="row">
                                <div class="col-sm-12">
                                  <div class="mb-3">
                                    <input
                                      class="form-control"
                                      type="text"
                                      placeholder="Enter creator name"
                                      v-model="creators[index].name"
                                    />
                                  </div>
                                </div>
                                <div class="col-sm-12">
                                  <div class="mb-3">
                                    <select
                                      class="form-select"
                                      aria-label="Default select example"
                                      v-model="creators[index].type"
                                    >
                                      <option value="" selected>
                                        Select collaborator type
                                      </option>
                                      <option value="Central government">
                                        Central government
                                      </option>
                                      <option value="Charity or foundation">
                                        Charity or foundation
                                      </option>
                                      <option value="For-profit organisation">
                                        For-profit organisation
                                      </option>
                                      <option value="GLAM">GLAM</option>
                                      <option
                                        value="Informal group or association"
                                      >
                                        Informal group or association
                                      </option>
                                      <option value="International body">
                                        International body
                                      </option>
                                      <option value="Local government">
                                        Local government
                                      </option>
                                      <option
                                        value="Non-Governmental Organisation"
                                      >
                                        Non-Governmental Organisation
                                      </option>
                                      <option value="Regional government">
                                        Regional government
                                      </option>
                                      <option value="Religious institutions">
                                        Religious institutions
                                      </option>
                                      <option value="School">School</option>
                                      <option value="Other">Other</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-1 col-sm-1 action">
                              <ul>
                                <li>
                                  <a
                                    @click="deleteNonExistingCreator(index)"
                                    class="delete"
                                    href="javascript:void(0)"
                                    title="Delete this creator"
                                    ><i class="far fa-trash-alt"></i
                                  ></a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
              <div class="advanced-form" id="advanced-form" ref="advancedform">
                <!-- heading-->
                <div class="heading main">
                  <h1>Advanced Information</h1>
                  <p>
                    The steps the recipe follows, the challenges it encounters,
                    the ingredients it uses and the outputs it produces are all
                    valuable information for other people who wish to organise a
                    similar initiative. Take the time to document this
                    information and contribute to knowledge sharing about social
                    innovation in cultural heritage and beyond.
                  </p>
                </div>
                <div class="heading">
                  <h2>Ingredients</h2>
                  <ul class="actionmenu">
                    <li class="prime">
                      <a href="#" @click="searchIngredientResource(0)"
                        ><i class="fas fa-plus"></i> Add existing ingredient</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="modalResShow = !modalResShow"
                      >
                        <span>or </span>Create New Ingredient</a
                      >
                      <b-modal
                        hide-footer
                        size="xl"
                        v-model="modalResShow"
                        title="Create new ingredient"
                        ><CreateNewIngredient></CreateNewIngredient
                      ></b-modal>
                    </li>
                  </ul>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="empty" v-if="resources.length === 0">
                      <p>
                        No Ingredients added yet. An Ingredient is a digital
                        asset (e.g. describing policy recommendations, a
                        methodology, a digital tool), which can be useful for
                        the organisation and implementation of a Recipe.
                      </p>
                    </div>
                    <div>
                      <div
                        class="element-item"
                        v-for="(ing, index) in resources"
                        :key="ing.id"
                      >
                        <div class="row">
                          <div class="col-lg-1 col-sm-1 ic">
                            <img src="../assets/ic-output.png" />
                          </div>
                          <div class="col-lg-10 col-sm-10">
                            <router-link
                              :to="{
                                name: 'resourceView',
                                params: { id: ing.id },
                              }"
                              target="_blank"
                            >
                              <a title="">
                                <h2>{{ ing.title }}</h2></a
                              >
                            </router-link>
                            <p>
                              {{ ing.description }}
                            </p>
                            <span class="typelocation">{{
                              ing.resourceType.toString()
                            }}</span>
                          </div>
                          <div class="col-lg-1 col-sm-1 action">
                            <ul>
                              <li>
                                <a
                                  class="delete"
                                  href="javascript:void(0)"
                                  @click="deleteResource(index)"
                                  title="Delete this output"
                                  ><i class="far fa-trash-alt"></i
                                ></a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="heading">
                  <h2>Steps</h2>
                  <ul class="actionmenu">
                    <li class="prime">
                      <a
                        href="javascript:void(0)"
                        @click.prevent="addNewStepForm"
                        ><i class="fas fa-plus"></i> Add Step</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="empty" v-if="steps.length === 0">
                      <p>
                        No Steps added yet. A Step is an activity that took/will
                        take place as part of the Recipe.
                      </p>
                    </div>
                    <div
                      class="element-item"
                      v-for="(step, index) in steps"
                      :key="index"
                    >
                      <div class="row">
                        <div class="col-lg-2 col-sm-2 ic">
                          <div class="counter">{{ index + 1 }}</div>
                        </div>
                        <div class="col-lg-9 col-sm-9">
                          <div class="row">
                            <div class="col">
                              <div class="mb-3">
                                <input
                                  class="form-control"
                                  type="text"
                                  placeholder="Enter step title"
                                  v-model="step.title"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <div class="mb-3">
                                <textarea
                                  class="form-control"
                                  rows="5"
                                  placeholder="Enter step description"
                                  v-model="step.description"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-1 col-sm-1 action">
                          <ul>
                            <li>
                              <a
                                class="delete"
                                @click="deleteStep(index)"
                                href="javascript:void(0)"
                                title="Delete this ingredient"
                                ><i class="far fa-trash-alt"></i
                              ></a>
                            </li>
                            <li>
                              <a
                                href="javascript:void(0)"
                                title="Insert ingredient after"
                                @click="addNewStepUnderneath(index)"
                                ><i class="fas fa-plus"></i
                              ></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="heading">
                  <h2>Challenges</h2>
                  <ul class="actionmenu">
                    <li class="prime">
                      <a
                        href="javascript:void(0)"
                        @click.prevent="addNewChallengeForm"
                        ><i class="fas fa-plus"></i> Add Challenge</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="empty" v-if="challenges.length === 0">
                      <p>
                        No Challenges added yet .Please describe the challenges
                        you encountered (or foreseen to encounter) along with
                        possible ways to address them.
                      </p>
                    </div>
                    <div
                      class="element-item"
                      :key="index"
                      v-for="(challenge, index) in challenges"
                    >
                      <div class="row">
                        <div class="col-lg-1 col-sm-1 ic">
                          <img src="../assets/ic-warn.png" />
                        </div>
                        <div class="col-lg-5 col-sm-5">
                          <div class="mb-3">
                            <textarea
                              class="form-control"
                              rows="5"
                              placeholder="Briefly describe the challenge"
                              v-model="challenge.description"
                            ></textarea>
                          </div>
                        </div>
                        <div class="col-lg-5 col-sm-5">
                          <div class="mb-3">
                            <textarea
                              class="form-control"
                              rows="5"
                              placeholder="Briefly describe a way to address it"
                              v-model="challenge.solution"
                            ></textarea>
                          </div>
                        </div>
                        <div class="col-lg-1 col-sm-1 action">
                          <ul>
                            <li>
                              <a
                                @click="deleteChallenge(index)"
                                class="delete"
                                href="javascript:void(0)"
                                title="Delete this ingredient"
                                ><i class="far fa-trash-alt"></i
                              ></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="heading">
                  <h2>Tips</h2>
                </div>
                <div class="row">
                  <div class="col-lg-1 col-sm-1 ic">
                    <img src="../assets/ic-tips.png" />
                  </div>
                  <div class="col-lg-11 col-sm-11">
                    <textarea
                      class="form-control"
                      rows="5"
                      v-model="tips"
                      placeholder="Enter pieces of practical advice, especially on matters whose importance is often not anticipated in advance."
                    ></textarea>
                  </div>
                </div>
                <div class="heading">
                  <h2>Outputs</h2>
                  <ul class="actionmenu">
                    <li class="prime">
                      <a href="#" @click="searchOutputs(0)"
                        ><i class="fas fa-plus"></i> Add Output</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="empty" v-if="outputs.length === 0">
                      <p>
                        No Outputs added yet. An Output is an expected end
                        result of a Recipe, e.g. it can be a link to a digital
                        or physical exhibition, a video, photographs from items
                        or events etc.
                      </p>
                    </div>
                    <div>
                      <div
                        class="element-item"
                        v-for="(out, index) in outputs"
                        :key="out.id"
                      >
                        <div class="row">
                          <div class="col-lg-1 col-sm-1 ic">
                            <img src="../assets/ic-output.png" />
                          </div>
                          <div class="col-lg-10 col-sm-10">
                            <router-link
                              :to="{
                                name: 'resourceView',
                                params: { id: out.id },
                              }"
                              target="_blank"
                            >
                              <a title="">
                                <h2>{{ out.title }}</h2></a
                              >
                            </router-link>
                            <p>
                              {{ out.description }}
                            </p>
                            <span class="typelocation">{{
                              out.resourceType.toString()
                            }}</span>
                          </div>
                          <div class="col-lg-1 col-sm-1 action">
                            <ul>
                              <li>
                                <a
                                  class="delete"
                                  href="javascript:void(0)"
                                  @click="deleteOutputs(index)"
                                  title="Delete this output"
                                  ><i class="far fa-trash-alt"></i
                                ></a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  <div v-else>
    <NoAccess></NoAccess>
  </div>
</template>


<script>
import CreateNewIngredient from "../components/resources/CreateNewIngredient";
import NoAccess from "../components/NoAccess";
import CreateNewOrganization from "../components/organizations/CreateNewOrganization";
import SearchPlugin from "../plugins/SearchPlugin";
import { mapGetters } from "vuex";
import { eventBus } from "../main";
import axios from "axios";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  data() {
    return {
      chooseExisting: false,
      file: null,
      emptyBannerAlert: false,
      saveAction: false,
      bannerUrl: null,

      // Open modal for new resource handler
      modalResShow: false,

      // Open modal for new organisation handler
      modalOrgShow: false,

      // Variable to define what type of data we are searching for
      searchSelector: "",

      // Collaborator search and addition variables
      chosenCollaborators: [],
      chosenCollaboratorName: [],
      chosenCollaboratorType: [],
      resourceCollaborators: {},
      resourceCollaboratorsArray: [],

      // outputs search and addition variables
      chosenOutputsName: [],
      chosenOutputsArray: [],
      chosenOutputs: {},

      // Challenge search and addition variables
      chosenChallengeName: [],
      chosenChallengesArray: [],
      chosenChallenges: {},

      // Image search and addition variables
      chosenImageId: null,

      // Ingredients: Recipe search and addition variables
      chosenIngRecipeName: [],
      chosenIngRecipes: {},
      chosenIngRecipesArray: [],

      // Ingredients: Resource search and addition variables
      chosenIngResourceName: [],
      chosenIngResources: {},
      chosenIngResourcesArray: [],
      creators: [],

      // Alert variables
      emptyTitleAlert: false,
      emptyDescriptionAlert: false,
      emptyImageResourceAlert: false,
      emptySelectedFocusAreasAlert: false,
      emptyTargetTypeAlert: false,
      showDismissibleAlert: false,
      selectedFocusAreas: [], // Must be an array reference!
      selectedFocusAreas2: [], // Must be an array reference!
      additionalFocusArea: "",
      additionalTargetGroupType: "",
      languages: [],
      countries: [],
      additionalLanguage: "",
      additionalCountry: "",
      visibility: "",
      status: "",
      Duration: [
        { text: "Short (1-6 months)", value: "Short (1-6 months)" },
        { text: "Medium (6-12 months)", value: "Medium (6-12 months)" },
        { text: "Long (1–3 years)", value: "Long (1–3 years)" },
        { text: "Very long (3+ years)", value: "Very long (3+ years)" },
      ],
      NumberOfParticipants: [
        { text: "Small (under 10)", value: "Small (under 10)" },
        { text: "Medium (10-20)", value: "Medium (10-20)" },
        { text: "Large (20-50)", value: "Large (20-50)" },
        { text: "Very large (over 50)", value: "Very large (over 50)" },
      ],
      Cost: [
        { text: "Basic expenses", value: "Basic expenses" },
        {
          text: "Small investment (e.g., organisation budget)",
          value: "Small investment (e.g., organisation budget)",
        },
        {
          text: "Medium investment (e.g., regional grant)",
          value: "Medium investment (e.g., regional grant)",
        },
        {
          text: "Large investment (e.g., national grant)",
          value: "Large investment (e.g., national grant)",
        },
        {
          text: "Very large investment (e.g., European grant)",
          value: "Very large investment (e.g., European grant)",
        },
      ],
      publicReadable: false,
      implemented: false,
      TargetGroupCountry: [
        // {text: 'Select target group country', value: '',: true},
        { text: "Germany", value: "Germany" },
        { text: "Greece", value: "Greece" },
        { text: "Finland", value: "Finland" },
        { text: "Italy", value: "Italy" },
        { text: "Netherlands", value: "Netherlands" },
        { text: "Spain", value: "Spain" },
        { text: "United Kingdom", value: "United Kingdom" },
        { text: "Other (specify)", value: "Other" },
      ],
      // single values  Gen Info
      title: "",
      description: "",
      imageResource: 0,
      tips: "",
      // services: '',
      keywords: [],
      duration: "",
      cost: "",
      numberOfParticipants: "",
      challenges: [],
      steps: [],
      creatorsWithId: [{ id: 0 }],
      recipes: [{ id: 0 }],
      resources: [],
      targetGroup: [{ type: [], description: "" }],
      outputs: [],
      url: "",
      challengesStepsWarning: false,
    };
  },
  components: {
    NoAccess,
    CreateNewIngredient,
    CreateNewOrganization,
  },
  watch: {
    chosenCollaboratorName: function () {
      return this.chosenCollaboratorName;
    },
  },
  beforeCreate: function () {
    if (this.$route.params.id) {
      axios
        .get("/recipe/" + this.$route.params.id, { withCredentials: true })
        .then((response) => {
          // The page has started fetching the data
          this.isEditable =
            response.data.rights === "OWN" || response.data.rights === "WRITE";
          this.loaded = true;

          // Single value data fetch and edit
          this.title = response.data.title;
          this.description = response.data.description;
          this.tips = response.data.tips;
          this.duration = response.data.duration ? response.data.duration : "";
          this.numberOfParticipants = response.data.numberOfParticipants
            ? response.data.numberOfParticipants
            : "";
          this.cost = response.data.cost ? response.data.cost : "";
          this.implemented = response.data.implemented;
          this.url = response.data.url;
          this.chosenImageId = response.data.imageResource;
          this.publicReadable = response.data.publicReadable;
          if (this.implemented) {
            this.status = "Completed";
          } else {
            this.status = "New or ongoing project idea";
          }
          if (this.publicReadable) {
            this.visibility = "Public";
          } else {
            this.visibility = "Private";
          }

          // Banner fetch
          if (response.data.bannerUrl) {
            this.bannerUrl = response.data.bannerUrl;
          }

          // Languages fetch
          if (response.data.languages.includes("Other")) {
            let index = response.data.languages.indexOf("Other");
            for (let i = 0; i <= index; i++) {
              this.languages.push(response.data.languages[i]);
              if (response.data.languages[index + 1] !== "") {
                // If the last value is not empty (deleted)
                this.additionalLanguage = response.data.languages[index + 1]
                  ? response.data.languages[index + 1]
                  : "";
              }
            }
          } else {
            this.languages = response.data.languages;
          }
          $("#languagemulti").val(this.languages);
          $("#languagemulti").multiselect("refresh");

          // Countries fetch
          if (response.data.countries.includes("Other")) {
            let index = response.data.countries.indexOf("Other");
            for (let i = 0; i <= index; i++) {
              this.countries.push(response.data.countries[i]);
              if (response.data.countries[index + 1] !== "") {
                // If the last value is not empty (deleted)
                this.additionalCountry = response.data.countries[index + 1]
                  ? response.data.countries[index + 1]
                  : "";
              }
            }
          } else {
            this.countries = response.data.countries;
          }
          $("#countrymulti").val(this.countries);
          $("#countrymulti").multiselect("refresh");

          if (response.data.areasOfFocus.includes("Other")) {
            let index = response.data.areasOfFocus.indexOf("Other");
            for (let i = 0; i <= index; i++) {
              this.selectedFocusAreas.push(response.data.areasOfFocus[i]);
              if (response.data.areasOfFocus[index + 1] !== "") {
                // If the last value is not empty (deleted)
                this.additionalFocusArea = response.data.areasOfFocus[index + 1]
                  ? response.data.areasOfFocus[index + 1]
                  : "";
              }
            }
          } else {
            this.selectedFocusAreas = response.data.areasOfFocus;
          }
          $("#focusmulti").val(this.selectedFocusAreas);
          $("#focusmulti").multiselect("refresh");

          if (response.data.targetGroup) {
            // this.targetGroup = response.data.targetGroup;
            for (let tg of response.data.targetGroup) {
              let tgType = []
              if (tg.type.includes("Other")) {
                let index = tg.type.indexOf("Other");
                for (let i = 0; i <= index; i++) {
                  tgType.push(tg.type[i]);
                  if (tg.type[index + 1] !== "") {
                    // If the last value is not empty (deleted)
                    this.additionalTargetGroupType = tg.type[
                      index + 1
                    ]
                      ? tg.type[index + 1]
                      : "";
                  }
                }
              } else {
                tgType = tg.type;
              }
              this.targetGroup[0].type = this.targetGroup[0].type.concat(tgType)
            }
          }
          let tg = this.targetGroup[0].type.map((type) => {
            return type;
          });
          $("#groupmulti").val(this.targetGroup[0].type);
          $("#groupmulti").multiselect("refresh");


          // Ingredients fetch
          if (response.data.ingredients) {
            for (let i = 0; i < response.data.ingredients.length; i++) {
              if (response.data.ingredients[i].recipe) {
                this.recipes.push(response.data.ingredients[i]);
                this.chosenIngRecipesArray.push({
                  id: response.data.ingredients[i].recipe.id,
                });
                this.chosenIngRecipeName.push(
                  response.data.ingredients[i].recipe.title
                );
              }
              if (response.data.ingredients[i].resource) {
                this.resources.push(response.data.ingredients[i].resource);
                this.chosenIngResourcesArray.push({
                  id: response.data.ingredients[i].resource.id,
                });
                this.chosenIngResourceName.push(
                  response.data.ingredients[i].resource.title
                );
              }
            }
          }

          // Outcomes fetch
          if (response.data.outputs) {
            for (let i = 0; i < response.data.outputs.length; i++) {
              this.outputs.push(response.data.outputs[i].resource);
              this.chosenOutputsArray.push({id: response.data.outputs[i].resource.id})
            }
          }

          // Collaborators fetch
          if (
            response.data.collaboratorsWithId &&
            response.data.collaboratorsWithId.length >= 1
          ) {
            for (let i = 0; i < response.data.collaboratorsWithId.length; i++) {
              this.chosenCollaborators.push(
                response.data.collaboratorsWithId[i]
              );
              this.resourceCollaboratorsArray.push(
                response.data.collaboratorsWithId[i]
              );
              this.chosenCollaboratorName.push(
                response.data.collaboratorsWithId[i].name
              );
              this.chosenCollaboratorType.push(
                response.data.collaboratorsWithId[i].type
              );
            }
          } else {
            this.resourceCollaboratorsArray = [];
            this.collaboratorsWithId = [];
            this.chosenCollaboratorName = [];
          }

          // Collaborators without ID fetch
          if (
            response.data.collaborators.length &&
            response.data.collaborators.length >= 1
          ) {
            this.creators = response.data.collaborators;
          } else {
            this.creators = [];
          }

          // Steps fetch
          for (let d = 0; d < Object.keys(response.data).length; d++) {
            if (Object.keys(response.data)[d] === "steps") {
              this.steps = [];
              for (let i = 0; i < response.data.steps.length; i++) {
                this.steps.push({
                  title: response.data.steps[i].title,
                  description: response.data.steps[i].description,
                });
              }
            }
          }

          // Challenges fetch
          if (response.data.challenges) {
            for (let i = 0; i < response.data.challenges.length; i++) {
              this.challenges.push(response.data.challenges[i]);
            }
          }

          // Target Groups fetch

          // Keywords fetch
          for (let d = 0; d < Object.keys(response.data).length; d++) {
            if (Object.keys(response.data)[d] === "keywords") {
              for (let i = 0; i < response.data.keywords.length; i++) {
                this.keywords.push({
                  key: response.data.keywords[i],
                  value: response.data.keywords[i],
                });
              }
            }
          }
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.saveAction && this.authenticatedUser) {
      this.boxOne = "";
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to leave without saving? If you do, all your work will be lost.",
          {
            title: "Warning",
            okVariant: "danger",
          }
        )
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            next();
          } else {
            next(false);
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    } else {
      next();
    }
  },
  mounted() {
    $("#languagemulti").multiselect({
      onChange: this.languageChanged,
    });
    $("#languagemulti").multiselect("refresh");
    $("#countrymulti").multiselect({
      onChange: this.countryChanged,
    });
    $("#countrymulti").multiselect("refresh");
    $("#groupmulti").multiselect({
      onChange: this.targetGroupChanged,
    });
    $("#groupmulti").multiselect("refresh");
    $("#focusmulti").multiselect({
      onChange: this.focusAreasChanged,
    });
    $("#focusmulti").multiselect("refresh");
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    FocusM() {
      let FocusM = this.selectedFocusAreas;
      return FocusM;
    },
    NewKeywordsArray() {
      let NewKeywordsArray = [];
      for (let i = 0; i < this.keywords.length; i++) {
        NewKeywordsArray.push(this.keywords[i].value);
      }
      return NewKeywordsArray;
    },
    IngredientsM() {
      let IngredientsM = [];
      for (let i = 0; i < this.recipes.length; i++) {
        // IngredientsM.push({recipe: this.recipes[i]})
        IngredientsM.push({ recipe: this.chosenIngRecipesArray[i] });
      }
      for (let i = 0; i < this.resources.length; i++) {
        // IngredientsM.push({resource: this.resources[i]})
        IngredientsM.push({ resource: this.chosenIngResourcesArray[i] });
      }
      return IngredientsM;
    },
    TargetGroupM() {
      let TargetGroupM = [];
      TargetGroupM = this.targetGroup;
      return TargetGroupM;
    },
    ImageResourceM() {
      let ImageResourceM = parseInt(this.imageResource, 10);
      return ImageResourceM;
    },
    ChallengesM() {
      let ChallengesM = [];
      for (let u = 0; u < this.challenges.length; u++) {
        // let resources = [{'id': this.chosenChallengesArray[u].id}]
        ChallengesM.push({
          description: this.challenges[u].description,
          solution: this.challenges[u].solution,
          // resources: resources
        });
      }
      return ChallengesM;
    },
  },
  beforeMount() {
    SearchPlugin.event.$on("updateterm", this.changeTerm);
    SearchPlugin.event.$on("showView", this.showView);
  },
  methods: {
    languageChanged: function () {
      this.languages =
        $("#languagemulti").val() === null ? [] : $("#languagemulti").val();
    },
    countryChanged: function () {
      this.countries =
        $("#countrymulti").val() === null ? [] : $("#countrymulti").val();
    },
    statusChanged() {
      if (this.status === "Completed") {
        this.implemented = true;
      } else {
        this.implemented = false;
      }
    },
    visibilityChanged() {
      if (this.visibility === "Public") {
        this.publicReadable = true;
      } else {
        this.publicReadable = false;
      }
    },
    targetGroupChanged: function () {
      this.targetGroup[0].type =
        $("#groupmulti").val() === null ? [] : $("#groupmulti").val();
    },
    focusAreasChanged: function () {
      this.selectedFocusAreas =
        $("#focusmulti").val() === null ? [] : $("#focusmulti").val();
    },
    bannerChanged(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.file = files[0];
    },
    searchForCollaborator(index) {
      this.searchSelector = "searchedOrganisation";
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchCategory("Organisations");
    },
    addNewNonExistingCreator() {
      this.creators.push({
        type: "",
      });
    },
    deleteNonExistingCreator(index) {
      this.creators.splice(index, 1);
    },
    scrollTo(refName, e) {
      let element = this.$refs[refName];
      let top = element.offsetTop;
      window.scrollTo({
        top: top,
        left: 0,
        behavior: "smooth",
      });
      $(".active").removeClass("active");
      e.currentTarget.classList.toggle("active");
    },
    searchOutputs(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedOutputs";
      this.outputsPosition = index;
      this.searchTerm("", "Ingredients");
    },
    // searchImage() {
    //   this.searchSelector = "searchedImage";
    //   this.searchTerm("", "Ingredients");
    // },
    searchIngredientResource(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedIngredientResource";
      this.ingResourcePosition = index;
      this.searchTerm("", "Ingredients");
    },
    checkForm() {
      this.emptyBannerAlert = false;
      this.emptyTitleAlert = false;
      this.emptyDescriptionAlert = false;
      this.emptyImageResourceAlert = false;
      this.emptySelectedFocusAreasAlert = false;
      this.emptyTargetTypeAlert = false;
      this.showDismissibleAlert = false;
      this.selectedFocusAreas =
        $("#focusmulti").val() === null ? [] : $("#focusmulti").val();

      if (
        this.selectedFocusAreas.includes("Other") &&
        this.selectedFocusAreas[this.selectedFocusAreas.length - 1] !==
          this.additionalFocusArea
      ) {
        if (this.additionalFocusArea !== "") {
          this.selectedFocusAreas.push(this.additionalFocusArea);
        } else {
          if (this.selectedFocusAreas.length === 1) {
            this.emptySelectedFocusAreasAlert = true;
          } else {
            this.selectedFocusAreas.splice(
              this.selectedFocusAreas.indexOf("Other"),
              1
            );
          }
        }
      }

      $("#focusmulti").val(this.selectedFocusAreas);
      $("#focusmulti").multiselect("refresh");
      // Additional Language handle
      if (
        this.languages.includes("Other") &&
        this.languages[this.languages.length - 1] !== this.additionalLanguage
      ) {
        if (this.additionalLanguage !== "") {
          this.languages.push(this.additionalLanguage);
        }
      }

      // $("#languagemulti").val(this.languages);
      // $("#languagemulti").multiselect("refresh");

      if (this.countries.includes("Other") && this.additionalCountry !== "") {
        this.countries.push(this.additionalCountry);
      }

      if (this.targetGroup[0].type.includes("Other")) {
        if (this.additionalTargetGroupType !== "") {
          this.targetGroup[0].type.push(this.additionalTargetGroupType);
        }
      }
      for (let i = 0; i < this.creators.length; i++) {
        if (!this.creators[i].name && !this.creators[i].description) {
          this.creators.splice(i, 1);
          i--;
        }
      }

      this.steps = this.steps.filter(
        (step) => step.title !== "" || step.description !== ""
      );

      if (this.file) {
        // If the user has uploaded a file after choosing an existing file, clear the chosen one and keep the new one
        this.chosenImageId = null;
      }
      if (this.chosenImageId) {
        // If the user has chosen an existing file after uploading a new one, clear the new one and keep the existing one
        this.file = null;
      }
      // check if all required fields are filled
      if (
        (!this.file && !this.bannerUrl) ||
        !this.title ||
        !this.description ||
        this.selectedFocusAreas.length === 0 ||
        this.emptySelectedFocusAreasAlert
      ) {
        if (!this.file && !this.bannerUrl) {
          this.emptyBannerAlert = true;
        }
        this.showDismissibleAlert = true;
        if (!this.title) {
          this.emptyTitleAlert = true;
        }
        if (!this.description) {
          this.emptyDescriptionAlert = true;
        }
        if (this.selectedFocusAreas.length === 0) {
          this.emptySelectedFocusAreasAlert = true;
        }
      } else {
        this.SendUserDataToAPI();
      }
    },
    deleteChallenge(index) {
      this.chosenChallengeName.splice(index, 1);
      this.challenges.splice(index, 1);
    },
    deleteStep(index) {
      this.steps.splice(index, 1);
    },
    addNewStepUnderneath(index) {
      this.steps.splice(index + 1, 0, { title: "", description: "" });
    },
    deleteCollaborator(index) {
      this.creatorsWithId.splice(index, 1);
      this.resourceCollaboratorsArray.splice(index, 1);
      this.chosenCollaborators.splice(index, 1);
      this.chosenCollaboratorName.splice(index, 1);
      this.chosenCollaboratorType.splice(index, 1);
    },
    deleteOutputs(index) {
      this.outputs.splice(index, 1);
      this.chosenOutputsArray.splice(index, 1);
      this.chosenOutputsName.splice(index, 1);
    },
    deleteResource(index) {
      this.resources.splice(index, 1);
      this.chosenIngResourcesArray.splice(index, 1);
      this.chosenIngResourceName.splice(index, 1);
    },
    addNewStepForm() {
      this.steps.push({ title: "", description: "" });
    },
    addNewChallengeForm() {
      this.challenges.push({ description: "", solution: "", resources: "" });
    },
    showMsgSuccess() {
      this.boxOne = "";
      if(this.$route.params.id){
        this.$bvModal
        .msgBoxOk("Your recipe has been successfully updated.", {
          okVariant: "success",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            this.$router.push({ name: "recipeView" });
          } else {
          }
        });
      }
      else{
        this.$bvModal
        .msgBoxOk("Your recipe has been successfully created.", {
          okVariant: "success",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            this.$router.push({ name: "recipes" });
          } else {
          }
        });}
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    showMsgFail() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Something went wrong. Please try again.", {
          okVariant: "danger",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            // window.location.reload()
          } else {
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    showMsgChallengesSteps() {
      if (
        !this.challengesStepsWarning &&
        this.steps.length > 0 &&
        this.steps[0].title === "" &&
        this.ChallengesM.length < 1
      ) {
        this.boxOne = "";
        this.$bvModal
          .msgBoxConfirm(
            "You have not entered any Steps or Challenges for your Recipe. Are you sure you wish to proceed?",
            {
              okVariant: "info",
            }
          )
          .then((value) => {
            this.boxOne = value;
            if (this.boxOne) {
              this.challengesStepsWarning = true;
              this.registerRecipe();
            } else {
              this.contactWarning = true;
            }
          });
        // .catch(error => {
        //   alert('An error occurred! Please refresh the page.' + error)
        // })
      } else {
        this.registerRecipe();
      }
    },
    registerRecipe() {
      this.saveAction = true;
      let CompletedRecipeFormData = "";
      CompletedRecipeFormData = {
        title: this.title,
        description: this.description,
        imageResource: this.chosenImageId,
        metadataLanguage: "string",
        tips: this.tips,
        keywords: this.NewKeywordsArray,
        duration: this.duration,
        cost: this.cost,
        // services: this.services,
        numberOfParticipants: this.numberOfParticipants,
        outputs: this.chosenOutputsArray,
        publicReadable: this.publicReadable,
        implemented: this.implemented,
        areasOfFocus: this.selectedFocusAreas,
        url: this.url,
        targetGroup: this.TargetGroupM,
        challenges: this.ChallengesM,
        steps: this.steps,
        collaboratorsWithId: this.resourceCollaboratorsArray,
        collaborators: this.creators,
        ingredients: this.IngredientsM,
        languages: this.languages,
        countries: this.countries,
      };
      if (!this.imageResource) {
        delete CompletedRecipeFormData.imageResource;
      }
      if (!this.tips) {
        delete CompletedRecipeFormData.tips;
      }
      if (this.steps.length === 0) {
        delete CompletedRecipeFormData.steps;
      }
      if (this.steps.length === 1) {
        if (this.steps[0].title === "" && this.steps[0].description === "") {
          delete CompletedRecipeFormData.steps;
        }
      }
      if (!this.keywords[0]) {
        delete CompletedRecipeFormData.keywords;
      }
      if (!this.challenges[0]) {
        delete CompletedRecipeFormData.challenges;
      }
      if (!this.duration) {
        delete CompletedRecipeFormData.duration;
      }
      if (!this.cost) {
        delete CompletedRecipeFormData.cost;
      }
      if (!this.numberOfParticipants) {
        delete CompletedRecipeFormData.numberOfParticipants;
      }
      if (this.selectedFocusAreas.length === 0) {
        delete CompletedRecipeFormData.areasOfFocus;
      }
      if (this.IngredientsM.length === 0) {
        delete CompletedRecipeFormData.ingredients;
      }
      if (this.targetGroup.length === 0) {
        delete CompletedRecipeFormData.targetGroup;
      }
      if (this.targetGroup.length === 1) {
        if (this.targetGroup[0].type === "") {
          delete CompletedRecipeFormData.targetGroup;
        }
      }
      if (this.$route.params.id) {
        // console.log("EDIT");
        axios
          .post(
            "/recipe/" + this.$route.params.id,
            CompletedRecipeFormData,
            { withCredentials: true },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((recipe) => {
            if (recipe) {
              if (this.file !== null) {
                let formData = new FormData();
                formData.append("file", this.file);
                let params = { id: recipe.data.id, file: formData };
                this.$store
                  .dispatch("uploadRecipeBanner", params)
                  .then((data) => {
                    this.showMsgSuccess();
                  })
                  .catch((error) => {
                    console.info(error);
                    this.showMsgFail();
                  });
              } else {
                this.showMsgSuccess();
              }
            } else {
              this.showMsgFail();
            }
          })
          .catch((error) => {
            console.info(error);
            this.showMsgFail();
          });
      } else {
        // console.log("ADD");
        this.$store
          .dispatch("createRecipe", CompletedRecipeFormData)
          .then((recipe) => {
            if (recipe) {
              if (this.file !== null) {
                let formData = new FormData();
                formData.append("file", this.file);
                let params = { id: recipe.id, file: formData };
                this.$store
                  .dispatch("uploadRecipeBanner", params)
                  .then((data) => {
                    this.showMsgSuccess();
                  })
                  .catch((error) => {
                    console.info(error);
                    this.showMsgFail();
                  });
              } else {
                this.showMsgSuccess();
              }
            } else {
              this.showMsgFail();
            }
          })
          .catch((error) => {
            console.info(error);
            this.showMsgFail();
          });
      }
    },
    SendUserDataToAPI() {
      if (this.targetGroup.length > 0) {
        let a = null;
        for (let i = 0; i < this.targetGroup.length; i++) {
          if (
            this.targetGroup[i].type === "" &&
            this.targetGroup[i].description !== ""
          ) {
            this.emptyTargetTypeAlert = true;
            window.alert(
              "You cannot create target without specifying its type"
            );
            // break
          } else a = a + 1;
        }

        if (this.targetGroup.length === a) {
          this.showMsgChallengesSteps();
        }
      }

      if (this.targetGroup.length === 0) {
        this.showMsgChallengesSteps();
      }
    },
    changeTerm(val) {
      this.sTerm = val;
    },
    showAll: function (token) {
      this.$search.searchNow();
    },
    showSearch: function () {
      this.$search.toggleSearch();
    },
    initOrg: function () {
      this.organisation = {};
    },
    initOutputs: function () {
      this.output = {};
    },
    initChallenge: function () {
      this.challenge = {};
    },
    initImage: function () {
      this.image = {};
    },
    initIngRecipe: function () {
      this.ingRecipe = {};
    },
    initIngResource: function () {
      this.ingResource = {};
    },
    showView: function (event) {
      if (this.searchSelector === "searchedOrganisation") {
        this.$store
          .dispatch("getOrganizationEntity", event.detail.id)
          .then((data) => {
            this.initOrg();
            this.organisation = data;
            this.chosenCollaborators.push(this.organisation);

            if (
              this.resourceCollaboratorsArray[this.collaboratorPosition] == null
            ) {
              this.chosenCollaboratorName.push(this.organisation.name);
              this.chosenCollaboratorType.push(this.organisation.type);
              this.resourceCollaborators["id"] = event.detail.id;
              this.resourceCollaboratorsArray.push(this.resourceCollaborators);
              this.resourceCollaborators = {};
            } else {
              this.resourceCollaboratorsArray.splice(
                this.collaboratorPosition,
                1
              );
              this.chosenCollaboratorName.splice(
                this.collaboratorPosition,
                1,
                this.organisation.name
              );
              this.chosenCollaboratorType.splice(
                this.collaboratorPosition,
                1,
                this.organisation.type
              );
              this.resourceCollaborators["id"] = event.detail.id;
              this.resourceCollaboratorsArray.push(this.resourceCollaborators);
              this.resourceCollaborators = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      } else if (this.searchSelector === "searchedOutputs") {
        this.$store
          .dispatch("getResourceEntity", event.detail.id)
          .then((response) => {
            this.initOutputs();
            this.output = response;
            this.outputs.push(response);
            this.chosenOutputsName.push(this.output.title);
            this.chosenOutputs["id"] = event.detail.id;
            this.chosenOutputsArray.push(this.chosenOutputs);
            this.chosenOutputs = {};
          })
          .catch((error) => {
            console.info(error);
          });
      }
      else if (this.searchSelector === "searchedImage") {
        this.chosenImageId = event.detail.id;
      }
      else if (this.searchSelector === "searchedIngredientResource") {
        this.$store
          .dispatch("getResourceEntity", event.detail.id)
          .then((response) => {
            this.initIngResource();
            this.ingResource = response;
            this.resources.push(response);
            // if (
            //   this.chosenIngResourcesArray[this.ingResourcePosition] == null
            // ) {
            this.chosenIngResourceName.push(this.ingResource.title);
            this.chosenIngResources["id"] = event.detail.id;
            this.chosenIngResourcesArray.push(this.chosenIngResources);
            this.chosenIngResources = {};
            // } else {
            //   this.chosenIngResourcesArray.splice(this.challengePosition, 1);
            //   this.chosenIngResourceName.splice(
            //     this.challengePosition,
            //     1,
            //     this.ingResource.title
            //   );
            //   this.chosenIngResources["id"] = event.detail.id;
            //   this.chosenIngResourcesArray.push(this.chosenIngResources);
            //   this.chosenIngResources = {};
            // }
          })
          .catch((error) => {
            console.info(error);
          });
      }
    },
    searchCategory: function (cat_type, token) {
      this.$search.searchNow({
        resulttype: cat_type,
        token: token,
      });
    },
    searchTerm: function (term, resulttype, token) {
      this.$search.searchNow({
        term: term,
        resulttype: resulttype,
        token: token,
      });
    },
  },
  created() {
    eventBus.$on("hideModal", (data) => {
      this.modalResShow = data;
    });
    eventBus.$on("organizationObject", (organizationObject) => {
      this.chosenCollaborators.push(organizationObject);
    });
    eventBus.$on("resourceTitle", (resourceTitle) => {
      this.chosenIngResourceName.push(resourceTitle);
    });
    eventBus.$on("resourceId", (resourceId) => {
      this.chosenIngResources["id"] = resourceId;
      this.chosenIngResourcesArray.push(this.chosenIngResources);
      this.$store.dispatch("getResourceEntity", resourceId).then((response) => {
        this.resources.push(response);
      });
      this.chosenIngResources = {};
    });
    eventBus.$on("hideOrgModal", (hideOrgModal) => {
      this.modalOrgShow = hideOrgModal;
    });
    eventBus.$on("organizationTitle", (organizationTitle) => {
      this.chosenCollaboratorName.push(organizationTitle);
    });
    eventBus.$on("organizationId", (organizationId) => {
      this.resourceCollaborators["id"] = organizationId;
      this.resourceCollaboratorsArray.push(this.resourceCollaborators);
      this.resourceCollaborators = {};
    });
  },
};
</script>

<style scoped>
.textareaDescription {
  height: 125px;
}

.height2 {
  height: 70px;
}
</style>

<style>
.custom-control {
  float: left;
  width: 100%;
}

.widthTextAreaOutputs {
  width: 450px;
  margin-left: 10px;
}

.CollaboratorsAlign {
  width: 280px;
  margin-left: 20px;
}

.CollaboratorsAlign2 {
  width: 280px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/RecipeCreate.vue